import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ToggleSwitch from 'components/consumer/ToggleSwitch';
import IconQuickship from 'components/icons/iconQuickship';
import QuickshipZipCodeEditLocation from 'components/essentials/QuickshipZipCodeEditLocation';
const QuickShipFilter = t0 => {
  const $ = _c(32);
  const {
    isChecked,
    isTablet,
    minHeight: t1,
    onChange: t2,
    onUserLocationChanged: t3,
    withLocation: t4,
    toggleVisible,
    showLabelOnMobile: t5
  } = t0;
  const minHeight = t1 === undefined ? true : t1;
  const onChange = t2 === undefined ? _temp : t2;
  const onUserLocationChanged = t3 === undefined ? null : t3;
  const withLocation = t4 === undefined ? false : t4;
  const showLabelOnMobile = t5 === undefined ? false : t5;
  const t6 = withLocation && minHeight;
  const t7 = withLocation && isTablet;
  let t8;
  if ($[0] !== t6 || $[1] !== t7 || $[2] !== withLocation) {
    t8 = classNames("flex flex-row justify-start [&_button]:border-0 [&_button]:bg-transparent flex-wrap xl:flex-nowrap", {
      "rounded-[3px] justify-start flex-row": withLocation,
      "md:min-h-[51px]": t6,
      "flex-wrap": t7
    });
    $[0] = t6;
    $[1] = t7;
    $[2] = withLocation;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const t9 = withLocation && isTablet;
  let t10;
  if ($[4] !== minHeight || $[5] !== t9 || $[6] !== withLocation) {
    t10 = classNames("flex items-center [&_span[class*=MuiSwitch-root]]:mt-1 [&_label]:mr-0", {
      "h-[2.8125rem]": minHeight,
      "[&_label]:mr-1": withLocation,
      "flex-col !items-start": t9
    });
    $[4] = minHeight;
    $[5] = t9;
    $[6] = withLocation;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== isChecked || $[9] !== isTablet || $[10] !== onChange || $[11] !== showLabelOnMobile || $[12] !== toggleVisible || $[13] !== withLocation) {
    t11 = isTablet ? <><div className={classNames("text-gray hidden xl:block", {
        "text-sm font-bold leading-[20px] text-gray": withLocation
      })}>Ready to Ship</div><ToggleSwitch isChecked={isChecked} onClick={() => onChange(!isChecked)}><span className={classNames("flex items-center md:text-sm md:font-bold text-sm font-bold text-gray relative -top-0.5 [&_svg]:relative [&_svg]:top-0.5", {
          active: isChecked
        })}><IconQuickship /></span></ToggleSwitch></> : <ToggleSwitch isChecked={isChecked} onClick={() => onChange(!isChecked)} toggleVisible={toggleVisible}><span className={classNames("flex items-center md:text-sm md:font-bold text-sm font-bold text-gray relative -top-0.5 [&_svg]:relative [&_svg]:top-0.5 gap-0.5", {
        active: isChecked
      })}><IconQuickship /><span className={classNames("relative top-0.5 text-gray", {
          "text-sm font-bold leading-[20px] text-gray": withLocation,
          block: showLabelOnMobile,
          "hidden xl:block": !showLabelOnMobile
        })}>Ready to Ship</span></span></ToggleSwitch>;
    $[8] = isChecked;
    $[9] = isTablet;
    $[10] = onChange;
    $[11] = showLabelOnMobile;
    $[12] = toggleVisible;
    $[13] = withLocation;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t11) {
    t12 = <div className={t10}>{t11}</div>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const t13 = !isTablet && minHeight;
  let t14;
  if ($[18] !== isTablet || $[19] !== t13) {
    t14 = classNames("flex items-center", {
      "h-5": isTablet,
      "h-[2.8125rem]": t13
    });
    $[18] = isTablet;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== isTablet || $[22] !== onUserLocationChanged || $[23] !== withLocation) {
    t15 = !!withLocation && <>{!isTablet && <span> </span>}<QuickshipZipCodeEditLocation onLocationChanged={onUserLocationChanged} /></>;
    $[21] = isTablet;
    $[22] = onUserLocationChanged;
    $[23] = withLocation;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t14 || $[26] !== t15) {
    t16 = <div className={t14}>{t15}</div>;
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t12 || $[29] !== t16 || $[30] !== t8) {
    t17 = <div className={t8}>{t12}{t16}</div>;
    $[28] = t12;
    $[29] = t16;
    $[30] = t8;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  return t17;
};
QuickShipFilter.propTypes = {
  isChecked: PropTypes.bool,
  isTablet: PropTypes.bool,
  minHeight: PropTypes.bool,
  onChange: PropTypes.func,
  onUserLocationChanged: PropTypes.func,
  withLocation: PropTypes.bool,
  toggleVisible: PropTypes.bool,
  showLabelOnMobile: PropTypes.bool
};
export default QuickShipFilter;
function _temp() {}